<!--
* @description  搜索内容面板 或 单项内容选择器
* @fileName  Seach-panel
* @author userName
* @date 2022-06-02 11:48:07
!-->
<template>
  <div id="Seach-panel" class="Seach-panel">
    <div class="seach_content">
      <el-scrollbar class="scroll_menu">
        <div
          class="seach_content-main"
          :style="{
            padding: padding + 'px',
            'font-size': ftSize + 'px',
            'margin-bottom': isSleSeach ? 15 + 'px' : '',
          }"
        >
          <div class="seach_content-main__default">
            <div class="default-main">
              <div
                class="default-main__item__main default-main__item__main-search flex_col"
              >
                <ul v-for="(item, index) in options" :key="index">
                  <li
                    class="default-main__item__main_option w_ellipsis"
                    :class="{
                      'text-active-color': atvIndex === index,
                      comm_disable: item[isDisable] == true,
                    }"
                    @click="
                      item[isDisable] ? '' : selectOpt(item[optionKey], index, item)
                    "
                  >
                    {{ item[optionKey] }}
                  </li>
                </ul>
              </div>
            </div>

            <div
              class="seach_content-main__empty flex_center2"
              v-if="options.length === 0"
            >
              抱歉！暂时无数据
            </div>
          </div>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 父辈向子辈传参
    options: {
      type: [Array],
      default: () => [],
    },
    // 集合关键key
    optionKey: {
      type: [String],
      default: "",
    },
    // 选中
    atvIndex: {
      type: [String, Number],
      default: null,
    },
    // 字体大小
    ftSize: {
      type: [String, Number],
      default: "",
    },
    // 内间距
    padding: {
      type: [String, Number],
      default: "",
    },
    // 是否禁用
    isDisable: {
      type: [String, Number],
      default: "",
    },
    isSleSeach: {
      type: [Boolean],
      default: false,
    },
  },
  name: "Seach-panel",
  data() {
    return {
      indAtv: null, //选中
    };
  },
  created() {
    // 实例被创建之后执行代码
  },
  computed: {
    // 计算属性
  },
  components: {
    // 组件的引用
  },
  methods: {
    // 方法
    selectOpt(item, index, data) {
      console.log("item,indexssassd", item, index);
      this.$emit("click", item, index, data);
      this.$emit("clickMore", item);
    },
  },
  mounted() {
    // 页面进入时加载内容
  },
  watch: {
    // 监测变化
  },
};
</script>
<style scoped lang="scss">
.comm_disable {
  color: #999 !important;
  cursor: not-allowed !important; // 表示一个红色的圈加一个斜杠
}
// 搜索
.seach_content {
  position: relative;
  z-index: 999;
  //   width: 100%;
  height: auto;
  //   margin-top: 4px;
  background: #ffffff;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  .text-active-color {
    color: #0046b9 !important;
    cursor: pointer;
  }

  .text-hover {
    @extend .text-active-color;

    &::after {
      content: "  ";
      width: 100%;
      height: 1px;
      background-color: #0046b9;
      position: relative;
      top: 12px;
      display: block;
    }
  }

  .seach_content-main {
    position: relative;
    padding: 8px 8px;
    font-size: 16px;
    color: #333333;
    box-sizing: border-box;

    .seach_content-main__default {
      position: relative;
      // height: auto;
      max-height: 304px;
      box-sizing: border-box;
      // overflow-x: hidden;
      // overflow-y: auto;

      .default-main {
        position: relative;
        // padding: 20px;
        .default-main__item__main {
          display: flex;
          flex-wrap: wrap;
        }

        .default-main__item__main_option {
          height: 32px;
          line-height: 32px;
          cursor: pointer;
          color: #333333;
          padding: 0 8px;
          box-sizing: border-box;
          font-size: 13px;
          border-radius: 4px;

          &:hover {
            background: #f7f8fa;
          }
        }
      }
    }

    .seach_content-main__empty {
      margin: 13px 0;
      font-weight: 400;
      color: #aaaaaa;
      line-height: 22px;
      font-size: 13px;
    }
  }
}
</style>
